import { Overlay, PortalContainerProvider, usePortalContainer } from "@theorgchartdev/storybook";
import { Resizer } from "@/appComponents/Blocks/Utils/Resizer/Resizer";
import Dragger from "@/appComponents/Blocks/Utils/Dragger/Dragger";
import cx from "classnames";
import React, { useState } from "react";
import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import FocusTrap from "focus-trap-react";
import { getContainerHeight, getContainerWidth } from "@/Utils/getContainerSize";

export const DefaultCardDimensions = () => {
  const initialWidth = getContainerWidth() * 0.8;
  const maxInitialHeight = 700;
  const calculatedHeight = getContainerHeight() * 0.8;
  const initialHeight = Math.min(calculatedHeight, maxInitialHeight);
  const minWidth = 400;
  const minHeight = 400;
  return {
    initialWidth,
    initialHeight,
    minWidth,
    minHeight
  };
};

// Escape closes via the overlay's onClose; focus returns to the canvas if the opener is gone.
export const cardFocusTrapOptions = {
  clickOutsideDeactivates: true,
  escapeDeactivates: false,
  setReturnFocus: previous =>
    previous?.isConnected && previous !== document.body
      ? previous
      : (document.getElementById("basecanvas") ?? false)
};

export const CardWrapper = ({
  show,
  prefixId,
  contentClass,
  customClass,
  onClose,
  otherHeaderProps,
  otherFooterProps,
  onMouseDownResize,
  size,
  initOffset,
  minWidth,
  minHeight,
  otherOverlayProps,
  children,
  focusTrap = false
}) => {
  const baseClass = "oc-card-wrapper";
  const outerPortalContainer = usePortalContainer();
  const [popoverContainer, setPopoverContainer] = useState(null);

  return (
    <CentralizedModalContainer show={show}>
      <Dragger fixed initOffset={initOffset} className={"oc-card-wrapper-dragger"}>
        {ref => (
          <FocusTrap
            active={focusTrap && show}
            focusTrapOptions={{
              ...cardFocusTrapOptions,
              ...(typeof focusTrap === "object" ? focusTrap : {})
            }}
          >
            <div className={`${baseClass}-focus-scope`} style={{ display: "contents" }}>
              <Overlay
                ref={ref}
                className={baseClass}
                id={`oc-card-wrapper--${prefixId}`}
                show={show}
                onClose={onClose}
                headerProps={{
                  headerActions: {
                    customAction: {
                      icon: "xmark",
                      buttonProps: { dataTestId: `${prefixId}-card-close-btn` },
                      onClick: onClose
                    }
                  },
                  modifier: "dark",
                  ...otherHeaderProps
                }}
                footerProps={{
                  ...otherFooterProps
                }}
                customStyle={{
                  width: size.width,
                  height: size.height,
                  minWidth: minWidth,
                  minHeight: minHeight,
                  maxWidth: size.width,
                  maxHeight: size.height
                }}
                {...otherOverlayProps}
              >
                <PortalContainerProvider container={popoverContainer ?? outerPortalContainer}>
                  <div className={cx(contentClass, customClass)}>{children}</div>
                </PortalContainerProvider>
                <Resizer onMouseDown={onMouseDownResize} />
              </Overlay>
              <div ref={setPopoverContainer} />
            </div>
          </FocusTrap>
        )}
      </Dragger>
    </CentralizedModalContainer>
  );
};
